import { renderPrompt } from '../services/promptsApi';

// The prompt text now lives in the backend prompt store (key: training.questions)
// and is editable from Settings → Prompt. Interpolation happens server-side.
async function generatePrompt(formData, script) {
  const { questionsPerVideo } = formData;
  return renderPrompt('training.questions', { questionsPerVideo, script });
}

export { generatePrompt };
